module.exports = __webpack_public_path__ + "static/media/picto-engrave-dark.ac2605bc.svg";